module.exports = __webpack_public_path__ + "static/img/product_catogary_4.37276c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/product_catogary_4.png
// module id = 3V27
// module chunks = 1